<template>
  <section class="uploadWordPage">
    <popup v-show="isShowUploadWord" bread="教材管理,课程管理,设置主题资料,编辑单词" title="编辑单词" @onBack="popup_back">
      <template slot="button">
        <el-button type="success" @click="saveUploadWord">保存并上传</el-button>
      </template>
      <infoUpDown :bread="'编辑单词'">
        <h3 class="group-tit">单词资料</h3>
        <commonEditWord
          ref="ref_commonUploadWord"
          :key="timestamp"
          :max-number="(30-currentNumber)"
          :form.sync="uploadForm"
          code="dc"
          @formChange="commonUploadWordChange"
        />
      </infoUpDown>
    </popup>
  </section>
</template>

<script>
import commonEditWord from '../components/commonEditWord.vue'
import { mapState } from 'vuex'
import { editWordApi } from '@api/teachBookManagement/courseManagement'
import { functionData } from '../../../../utils/reg'
// import { applyData, findApplyHistory } from '@/api/refund/refundApply'
export default {
  components: {
    commonEditWord
  },
  props: {
    currentNumber: {
      type: Number,
      default: 0
    },
    timestamp: {
      type: Number,
      default: 0
    },
    themeRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isShowUploadWord: false,
      commonUploadForm: {},
      uploadForm: {
        wordList: []
      }
    }
  },
  computed: {
    ...mapState('settingThemeData', ['editWordList'])
  },

  watch: {
    timestamp: function (val) {
      this.isShowUploadWord = true
      this.dataChange()
    }
  },
  created () {

  },
  methods: {
    // 返回
    dataChange() {
      const array = []
      this.editWordList.forEach(e => {
        const item = {
          voice: functionData(e, 'pronunciation', 'Pronunciation'),
          img: functionData(e, 'cardChart', 'CardChart'),
          video: functionData(e, 'mouthShape', 'MouthShape'),
          // voice: [{
          //   name: e.pronunciationName,
          //   id: e.id,
          //   url: e.pronunciationPath
          // }],
          // img: [{
          //   name: e.cardChartName,
          //   id: e.id,
          //   url: e.cardChartPath
          // }],
          // video: [{
          //   name: e.mouthShapeName,
          //   id: e.id,
          //   url: e.mouthShapePath
          // }],
          wordName: e.wordName,
          id: e.id
        }
        array.push(item)
      })
      this.uploadForm.wordList = array
      console.log(this.uploadForm)
    },
    popup_back () {
      this.isShowUploadWord = false
      // this.$emit('resetFetchData')
    },
    commonUploadWordChange (form) {
      this.commonUploadForm = form
    },
    async saveUploadWord () {
      if (!this.$refs.ref_commonUploadWord.validateForm()) {
        this.$message.error('请正确填写信息')
        return false
      }
      const params = []
      console.log(this.uploadForm.wordList)
      for (const item of this.uploadForm.wordList) {
        params.push({
          wordName: item.wordName,
          cardChartName: item.img[0].paramsFileName || item.img[0].fileName,
          cardChartPath: item.img[0].matchPathName || item.img[0].paramsUrl,
          wordPronunciationName: item.voice[0].paramsFileName || item.voice[0].fileName,
          wordPronunciationPath: item.voice[0].matchPathName || item.voice[0].paramsUrl,
          mouthShapeName: item.video[0].paramsFileName || item.video[0].fileName,
          mouthShapePath: item.video[0].matchPathName || item.video[0].paramsUrl,
          teachingThemeId: this.themeRow.id,
          meansType: 5,
          del: true,
          id: item.id,
          select: true
        })
      }
      console.log(params)
      try {
        await Promise.all(params.map(async (item) => {
          // 等待异步操作完成，返回执行结果
          return await editWordApi({ wordMeansList: [item] })
        }))

        this.isShowUploadWord = false
        this.$emit('resetFetchData')
      } catch (e) {
        this.$message.closeAll()
        this.$message.error(e)
      }
    }
  }
}
</script>

<style lang='scss'>
.uploadWordPage{
  .group-tit{
    margin: 24px 0;color:#53402B;display: flex;
    align-items: center;
    span{color: #898884;}
    &::before{
      content: '';
      width: 6px;
      height: 22px;
      display: inline-block;
      background: #FCDA6F;
      margin-right: 8px;
      border-radius: 9px;
    }
  }
}
.upload-form-self{
  display: flex;
  flex-wrap: wrap;
  .el-form-item{
    width: 40%;
    &:nth-child(odd){
      margin-right: 10%;
    }
  }
}
</style>
